import { ReactComponent as GitPullRequestIcon } from 'assets/icons/git-pull-request2.svg';
import { ReactComponent as GitMergeIcon } from 'assets/icons/git-merge.svg';
import { ReactComponent as GitClosedIcon } from 'assets/icons/git-closed.svg';
import { ReactComponent as OpenPRIcon } from 'assets/icons/open-pr.svg';
import { ReactComponent as TimeIcon } from 'assets/icons/time.svg';
import { ReactComponent as CommitIcon } from 'assets/icons/commit.svg';
import { Tooltip } from '@mui/material';
import './styles.scss';
import { IPRStats } from 'interface/pullRequestInterface';

interface IStatsCardProps {
  stats: IPRStats[] | undefined;
}

const formatDuration = (duration: number): string => {
  const hours = Math.floor(duration / 3600);
  const days = Math.floor(hours / 24);
  return days > 0 ? `${days} days` : `${hours} hours`;
};

export default function StatsCards({ stats }: IStatsCardProps) {
  console.log(stats);
  const statsData = stats?.[0] ?? {
    Total: 0,
    Open: 0,
    Closed: 0,
    ClosedNotMerged: 0,
    Merged: 0,
    AvgTimeOpen: 0,
    AvgPRDuration: 0,
    AvgCommits: 0,
  };
  return (
    <div className="statistics_cards">
      <div className="card-wrapper">
        <div className="cards horizontal">
          <div className="card">
            <div className="icon_wrapper">
              <GitPullRequestIcon />
            </div>
            <div className="content_wrapper">
              <p className="label">Total PRs</p>
              <p className="sub_text">{statsData.Total || '-'}</p>
            </div>
          </div>

          <div className="card">
            <div className="icon_wrapper">
              <GitMergeIcon />
            </div>
            <div className="content_wrapper">
              <p className="label">Merged PRs</p>
              <p className="sub_text">{statsData.Merged || '-'}</p>
            </div>
          </div>

          <div className="card">
            <div className="icon_wrapper">
              <OpenPRIcon />
            </div>
            <div className="content_wrapper">
              <p className="label">Open PRs</p>
              <p className="sub_text">{statsData.Open || '-'}</p>
            </div>
          </div>

          <Tooltip
            placement="bottom"
            PopperProps={{ className: 'cycle-tooltip' }}
            title={
              <div className="cycle-wrapper">
                <div className="cycle divider">
                  <p className="title">Merged</p>
                  <p className="title">{statsData.Merged || '-'}</p>
                </div>
                <div className="cycle">
                  <p className="title">Closed (Not Merged)</p>
                  <p className="title">{statsData.ClosedNotMerged || '-'}</p>
                </div>
              </div>
            }>
            <div className="card">
              <div className="icon_wrapper">
                <GitClosedIcon />
              </div>
              <div className="content_wrapper">
                <p className="label">Closed PRs</p>
                <p className="sub_text">{statsData.Closed || '-'}</p>
              </div>
            </div>
          </Tooltip>

          <div className="card">
            <div className="icon_wrapper">
              <TimeIcon />
            </div>
            <div className="content_wrapper">
              <p className="label">Average Time Open</p>
              <p className="sub_text">
                {statsData.AvgTimeOpen
                  ? formatDuration(statsData.AvgTimeOpen)
                  : '-'}
              </p>
            </div>
          </div>

          <div className="card">
            <div className="icon_wrapper">
              <TimeIcon />
            </div>
            <div className="content_wrapper">
              <p className="label">Average PR Duration</p>
              <p className="sub_text">
                {statsData.AvgPRDuration
                  ? formatDuration(statsData.AvgPRDuration)
                  : '-'}
              </p>
            </div>
          </div>

          <div className="card">
            <div className="icon_wrapper">
              <CommitIcon />
            </div>
            <div className="content_wrapper">
              <p className="label">Average Commits</p>
              <p className="sub_text">
                {statsData.AvgCommits
                  ? Number(statsData.AvgCommits).toFixed(2)
                  : '-'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
